// Syncs size radio buttons into the product form's hidden input[name="id"] (the add-to-cart source of truth)
// and swaps the price, compare price and availability that Liquid pre-rendered for each variant.
class SVariantRadios extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', (event) => {
      const radio = event.target;
      if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
      this.#select(radio);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #select(radio) {
    const form = this.closest('form');
    const idInput = form?.querySelector('input[type="hidden"][name="id"]');
    if (idInput) idInput.value = radio.value;

    const scope = this.closest('[data-showcase]') || document;
    scope.querySelectorAll('[data-variant-price]').forEach((node) => {
      node.hidden = node.dataset.variantPrice !== radio.value;
    });

    const available = radio.dataset.available === 'true';
    const submit = form?.querySelector('button[name="add"]');
    if (submit) {
      submit.toggleAttribute('disabled', !available);
      const label = submit.querySelector('[data-add-label]');
      if (label) label.textContent = available ? submit.dataset.addText : submit.dataset.soldText;
    }
  }
}

if (!customElements.get('s-variant-radios')) customElements.define('s-variant-radios', SVariantRadios);
